import React, { useEffect, useState } from 'react'
import { useEditPresaleInfoMutation, useSinglePresaleInfoMutation, useActiveEditPresaleInfoMutation, useCheckEditPresaleInfoMutation } from './store/ReduxApis';
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import toast, { Toaster } from 'react-hot-toast';
import { useParams } from 'react-router-dom'
import Web3 from "web3";

function EditPresaleRound() {
    let accounts = [];

    const web3 = new Web3(process.env.REACT_APP_BSC_CHAIN_TESTNET_RPC_URL);
    let CONTRACT_ADDRESS = process.env.REACT_APP_PRESALE_CONTRACT
    let CONTRACT_ABI = JSON.parse(process.env.REACT_APP_PRESALE_CONTRACT_ABI);
    let stkTokenContract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);

    const switchToBNBTestnet = async () => {
        try {
            await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: "0x61" }], // BNB Smart Chain Testnet (Chain ID: 97)
            });
            toast.success("Switched to BNB Smart Chain!");
        } catch (switchError) {
            if (switchError.code === 4902) {
                // If network is not added, add it
                await window.ethereum.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: "0x61",
                            chainName: "Binance Smart Chain",
                            rpcUrls: [process.env.REACT_APP_BSC_CHAIN_RPC_URL],
                            nativeCurrency: {
                                name: "BNB",
                                symbol: "BNB",
                                decimals: 18,
                            },
                        },
                    ],
                });
                toast.success("BNB Smart Chain  added!");
            } else {
                toast.error("Failed to switch network.");
            }
        }
    };


    const connectWallet = async () => {
        if (typeof window === "undefined" || !window.ethereum) {
            alert("MetaMask not found. Please install MetaMask.");
            return;
        }

        // ✅ Check for multiple wallet providers first
        const detectedWallets = [];

        // Check for common wallet providers
        if (window.ethereum.isExodus) detectedWallets.push('Exodus');
        if (window.ethereum.isCoinbaseWallet || window.ethereum.selectedProvider?.isCoinbaseWallet) detectedWallets.push('Coinbase');
        if (window.ethereum.isRabby) detectedWallets.push('Rabby');
        if (window.ethereum.isTrustWallet) detectedWallets.push('Trust Wallet');
        if (window.ethereum.isMetaMask) detectedWallets.push('MetaMask');

        // Check providers array if available
        if (window.ethereum.providers && Array.isArray(window.ethereum.providers)) {
            window.ethereum.providers.forEach(provider => {
                if (provider.isExodus && !detectedWallets.includes('Exodus')) detectedWallets.push('Exodus');
                if ((provider.isCoinbaseWallet || provider.selectedProvider?.isCoinbaseWallet) && !detectedWallets.includes('Coinbase')) detectedWallets.push('Coinbase');
                if (provider.isRabby && !detectedWallets.includes('Rabby')) detectedWallets.push('Rabby');
                if (provider.isTrustWallet && !detectedWallets.includes('Trust Wallet')) detectedWallets.push('Trust Wallet');
                if (provider.isMetaMask && !detectedWallets.includes('MetaMask')) detectedWallets.push('MetaMask');
            });
        }

        console.log('Detected wallets:', detectedWallets);

        // ✅ If multiple wallets detected, show error
        if (detectedWallets.length > 1) {
            alert("Multiple wallets detected, please disable wallets except metamask and refersh the page");
            return;
        }

        // ✅ If only one wallet but it's not MetaMask, show error
        if (detectedWallets.length === 1 && !detectedWallets.includes('MetaMask')) {
            alert("Multiple wallets detected, please disable wallets except metamask and Refersh the page");
            return;
        }

        // ✅ Find MetaMask provider
        let metaMaskProvider = null;

        if (window.ethereum.providers && Array.isArray(window.ethereum.providers)) {
            metaMaskProvider = window.ethereum.providers.find(provider => provider.isMetaMask);
        } else if (window.ethereum.isMetaMask) {
            metaMaskProvider = window.ethereum;
        }

        // ❌ If no MetaMask detected
        if (!metaMaskProvider) {
            alert("MetaMask not detected. Please install MetaMask and disable other wallets.");
            return;
        }

        try {
            // ✅ Use MetaMask provider directly
            const accounts = await metaMaskProvider.request({ method: "eth_requestAccounts" });

            // ✅ Check if MetaMask is unlocked
            if (typeof metaMaskProvider._metamask?.isUnlocked === "function") {
                const unlocked = await metaMaskProvider._metamask.isUnlocked();
                if (!unlocked) {
                    alert("Please unlock MetaMask.");
                    return;
                }
            }

            const web3 = new Web3(metaMaskProvider);
            console.log("✅ Connected to MetaMask:", accounts[0]);
            stkTokenContract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);

            const chainId = await web3.eth.getChainId();
            if (chainId !== 97) {
                await switchToBNBTestnet();
                return; // Stop execution until user switches network
            }


            // ✅ Check if connected account is the contract owner
            try {
                const ownerAddress = await stkTokenContract.methods.owner().call();
                if (accounts[0].toLowerCase() !== ownerAddress.toLowerCase()) {
                    const shortAddress = `${ownerAddress.slice(0, 6)}...${ownerAddress.slice(-4)}`;
                    alert(`Wrong wallet connected! Please connect with owner wallet: ${shortAddress}`);
                    return;
                }
            } catch (ownerError) {
                console.error("Error fetching contract owner:", ownerError);
                // Continue without owner check if contract call fails
            }

            return accounts[0];
        } catch (error) {
            console.error("❌ MetaMask connection error:", error);
            if (error.code === 4001) {
                alert("MetaMask connection was rejected by user.");
            } else {
                alert("Failed to connect to MetaMask. Please try again.");
            }
        }
    };

    // Function to get today's date in 'DD-MM-YYYY' format
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const { id } = useParams();
    const [presalePost, responseInfo1] = useSinglePresaleInfoMutation();
    const [createPost, responseInfo] = useEditPresaleInfoMutation();
    const [activeEdit, responseActiveEditInfo] = useActiveEditPresaleInfoMutation();
    const [checkEdit, responseCheckEditInfo] = useCheckEditPresaleInfoMutation();
    const [presaleTitle, setPresaleTitle] = useState("")
    const [startDate, setStartDate] = useState(getCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDate());
    const [startDateTimestamp, setStartDateTimestamp] = useState(null);
    const [endDateTimestamp, setEndDateTimestamp] = useState(null);
    const [supply, setSupply] = useState("")
    const [price, setPrice] = useState("")
    const [MinAmount, setMinAmount] = useState("")
    const [MaxAmount, setMaxAmount] = useState("")
    const [error, setError] = useState('');
    const [presaleData, setPresaleData] = useState({})
    const [errorValid, setErrorValid] = useState({});


    const history = useHistory();

    // Convert YYYY-MM-DD (from <input type="date">) to IST timestamp (seconds)
    const toISTTimestamp = (dateString) => {
        if (!dateString) return null;

        // Create a date object from input (which is plain date without time)
        const localDate = new Date(dateString);

        // Format it in IST timezone
        const istDate = new Date(
            localDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
        );

        return Math.floor(istDate.getTime() / 1000); // return seconds
    };


    const getOneData = async () => {
        const updateUserDetails = await presalePost({ "_id": id })
            .then(res => {
                // setPresaleData(res?.data?.data, "res")
                const data = res?.data?.data;
                setPresaleData(data);
                setStartDate(data?.startDate);
                setEndDate(data?.endDate);
            })
        console.log(updateUserDetails, "details")
    }

    useEffect(() => {
        getOneData();
    }, [])

    const validateDates = (newStartDate, newEndDate) => {
        const errors = {};
        if (!startDate) {
            errors.startDate = "Start Date is required";
        }
        if (!endDate) {
            errors.endDate = "End Date is required";
        }
        if (newStartDate === newEndDate) {
            errors.dateValidation = "Start Date and End Date cannot be the same.";
        }
        else if (newStartDate > newEndDate) {
            errors.dateValidation = "End Date should be greater than Start Date.";
        }

        if (!presaleData?.supply || isNaN(presaleData?.supply)) {
            errors.supply = "Supply should be a number";
        }
        // if (!presaleData?.price || isNaN(presaleData?.price)) {
        //     errors.price = "Price should be a number";
        // }
        if (!presaleData?.priceinusd || isNaN(presaleData?.priceinusd)) {
            errors.priceinusd = "Price in USD should be a number";
        }
        if (!presaleData?.salepercentage || isNaN(presaleData?.salepercentage)) {
            errors.salepercentage = "Sale Percentage should be a number";
        }

        setErrorValid(errors);
        return Object.keys(errors).length === 0;
    };


    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);
        setStartDateTimestamp(toISTTimestamp(newStartDate));
        validateDates(newStartDate, endDate);
    };

    const handleEndDateChange = (e) => {
        const newEndDate = e.target.value;
        setEndDate(newEndDate);
        setEndDateTimestamp(toISTTimestamp(newEndDate));
        validateDates(startDate, newEndDate);
    };

    const newPost = {
        _id: id,
        presaleTitle: presaleData?.presaleTitle,
        startDate: startDate,
        endDate: endDate,
        supply: presaleData?.supply,
        // "price": Number(presaleData?.price),
        priceinusd: Number(presaleData?.priceinusd),
        salepercentage: presaleData?.salepercentage,
        hash: presaleData.hash
        // "minAmount": presaleData?.minAmount,
        // "maxAmount": presaleData?.maxAmount,
    }

    const startPresaleAndEdit = async (round) => {
        try {
            // const account = await connectWallet();
            // if (!account) return;

            // const ownerAddress = await stkTokenContract.methods.owner().call();

            // // ✅ Validate connected wallet with contract owner
            // if (account.toLowerCase() !== ownerAddress.toLowerCase()) {
            //     const shortAddress = `${ownerAddress.slice(0, 6)}...${ownerAddress.slice(-4)}`;
            //     alert(`Please connect ${shortAddress} wallet address`);
            //     return;
            // }

            // // Validate round data
            // if (!presaleData?.roundNum || !startDate || !endDate || !presaleData?.priceinusd || !presaleData?.supply) {
            //     console.error("Invalid round data", round);
            //     alert("Missing round details!");
            //     return;
            // }

            // ✅ Fetch totalRounds and increment
            const _roundId = parseInt(presaleData?.roundNum);

            // const _startTime = Math.floor(new Date(startDate).getTime() / 1000);
            // const _endTime = Math.floor(new Date(endDate).getTime() / 1000);
            const _startTime = presaleData?.startDateTimestamp;
            const _endTime = presaleData?.endDateTimestamp;
            const _tokenPriceUSDT = web3.utils.toWei(presaleData?.priceinusd.toString(), "ether");
            const _isActive = true
            const _cap = parseInt(presaleData?.supply, 10);
            // const _isActive = presaleData.status === "Open" ? true : false;

            console.log("EditParams:", { _roundId, _startTime, _endTime, _tokenPriceUSDT, _cap, _isActive });

            // ✅ Blockchain transaction
            // const tx = await stkTokenContract.methods
            //     .editRound(_roundId, _startTime, _endTime, _tokenPriceUSDT, _isActive, _cap,)
            //     .send({ from: account });

            // console.log("Transaction Successful:", tx);

            // // ✅ Update API with transaction details using activeEdit
            // await activeEdit({
            //     ...round,
            //     // roundNum: tx.events.RoundAdded.returnValues.roundId,
            //     transactionHash: tx.transactionHash
            // });

            alert("Presale Updated successfully!");
        } catch (error) {
            console.error("Error starting presale:", error);
            alert("Transfer failed, Check console");
        }
    };

    // const EditPresale = async (e) => {
    //     e.preventDefault();
    //     if (!validateDates(startDate, endDate)) {
    //         return;
    //     }
    //     console.log("addPresale:", newPost);

    //     if (presaleData?.hash === "") {
    //         await createPost(newPost);
    //     }
    //     else {
    //         // await activeEdit(newPost)
    //         // ✅ Execute smart contract call + activeEdit update
    //         // await startPresaleAndEdit(newPost);

    //         try {
    //             const checkResponse = await checkEdit(newPost).unwrap();

    //             if (checkResponse?.status === "success") {
    //                 // ✅ If check passes, call Metamask + activeEdit
    //                 await startPresaleAndEdit(newPost);
    //             } else {
    //                 toast(checkResponse?.message || "Check failed!");
    //             }
    //         } catch (error) {
    //             console.error("Check API failed:", error);
    //             toast(error?.data?.message || "Validation failed!");
    //         }
    //     }
    // }

    // Common Save + Deploy flow
const handlePresaleAction = async (e, actionType) => {
    e.preventDefault();

    if (!validateDates(startDate, endDate)) return;

    console.log(`${actionType === "save" ? "Saving" : "Deploying"} Presale:`, newPost);

    try {
        if (actionType === "save") {
            // API for saving only
            await createPost(newPost);
        } else if (actionType === "deploy") {
            // Check before deploying
            const checkResponse = await checkEdit(newPost).unwrap();

            if (checkResponse?.status === "success") {
                await startPresaleAndEdit(newPost); // deploy contract + API
            } else {
                toast(checkResponse?.message || "Validation failed!");
            }
        }
    } catch (error) {
        console.error(`${actionType} error:`, error);
        toast(error?.data?.message || `Error while ${actionType} presale!`);
    }
};

    useEffect(() => {
        if (responseInfo?.data?.status === "success") {
            toast(responseInfo?.data?.message)
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            setTimeout(() => history.push('/presale'), 2000);
        } else if (responseInfo?.error?.data?.status === "fail") {
            toast(responseInfo?.error?.data?.message)
        }
        else if (responseInfo?.status === "fulfilled") {
            toast(responseInfo?.data?.message)
        }

    }, [responseInfo])


    useEffect(() => {
        if (responseActiveEditInfo?.data?.status === "success") {
            toast(responseActiveEditInfo?.data?.message)
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            setTimeout(() => history.push('/presale'), 2000);
        } else if (responseActiveEditInfo?.error?.data?.status === "fail") {
            toast(responseActiveEditInfo?.error?.data?.message)
        }
        else if (responseActiveEditInfo?.status === "fulfilled") {
            toast(responseActiveEditInfo?.data?.message)
        }

    }, [responseActiveEditInfo])

    return (
        <div>
            <Toaster />

            <div className="content-wrapper">

                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6 text">
                                <h1>Edit Presale</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Edit Presale</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6 offset-md-2">

                                <div className="card card-outline card-primary">
                                    <form 
                                    // onSubmit={(e) => EditPresale(e)}
                                    >
                                        <div className="card-body">

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='presaleTile'> Presale Title </label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Presale Title" 
                                                    name='presaleTitle'
                                                    value={presaleData?.presaleTitle}
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            presaleTitle: e.target.value
                                                        })
                                                    }}
                                                    disabled
                                                    required />
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='supply'> Supply </label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Supply" 
                                                    name='supply'
                                                    value={presaleData?.supply}
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            supply: e.target.value
                                                        })
                                                    }}
                                                    required />
                                                {errorValid.supply && <p style={{ color: 'red' }}>{errorValid.supply}</p>}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'> Price ( BNB )</label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Price" 
                                                    name='price' required
                                                    onChange={e => {
                                                        setPresaleData({
                                                        ...presaleData,
                                                        price: e.target.value
                                                      })
                                                    }}
                                                    value={presaleData?.price}
                                                     />
                                                      {errorValid.price && <p style={{ color: 'red' }}>{errorValid.price}</p>}
                                            </div> */}

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'> Price ( USD )</label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Price" 
                                                    name='price' required
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            priceinusd: e.target.value
                                                        })
                                                    }}
                                                    value={presaleData?.priceinusd}
                                                />
                                                {errorValid.priceinusd && <p style={{ color: 'red' }}>{errorValid.priceinusd}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'>Sale Percentage</label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Price" 
                                                    name='price' required
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            salepercentage: e.target.value
                                                        })
                                                    }}
                                                    value={presaleData?.salepercentage}
                                                />
                                                {errorValid.salepercentage && <p style={{ color: 'red' }}>{errorValid.salepercentage}</p>}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='MinAmount'> MinAmount </label>
                                                <input type="text"
                                                    className="addPost"
                                                    // placeholder="MinAmount" 
                                                    name='MinAmount'  
                                                    required 
                                                    onChange={e => {
                                                        setPresaleData({
                                                        ...presaleData,
                                                        minAmount: e.target.value
                                                      })
                                                    }}
                                                    value={presaleData?.minAmount}
                                                    // value={presaleData?.MinAmount || '0'}
                                                    />
                                                    {errorValid.minAmount && <p style={{ color: 'red' }}>{errorValid.minAmount}</p>}
                                            </div> */}

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='MaxAmount'> MaxAmount </label>
                                                <input type="text" className="addPost"
                                                    // placeholder="MaxAmount" 
                                                    name='MaxAmount' required 
                                                    onChange={e => {
                                                        setPresaleData({
                                                        ...presaleData,
                                                        maxAmount: e.target.value
                                                      })
                                                    }}
                                                    value={presaleData?.maxAmount}
                                                    />
                                                     {errorValid.maxAmount && <p style={{ color: 'red' }}>{errorValid.maxAmount}</p>}
                                                     {errorValid.amountValidation && <p style={{ color: 'red' }}>{errorValid.amountValidation}</p>}
                                            </div> */}

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='startDate'> Start Date </label>
                                                <input type="date" className="addPost"
                                                    // placeholder="Start Date" 
                                                    // min={getCurrentDate()}
                                                    name='startDate' value={startDate} onChange={handleStartDateChange} required />
                                                {errorValid.startDate && <p style={{ color: 'red' }}>{errorValid.startDate}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='endDate'> End Date </label>
                                                <input type="date" className="addPost"
                                                    // placeholder="End Date" 
                                                    // min={getCurrentDate()}
                                                    name='endDate' value={endDate} onChange={handleEndDateChange} required />
                                                {errorValid.endDate && <p style={{ color: 'red' }}>{errorValid.endDate}</p>}
                                                {errorValid.dateValidation && <p style={{ color: 'red' }}>{errorValid.dateValidation}</p>}
                                            </div>

                                            <div
                                            className='d-flex justify-content-between gap-2'>
                                                <button type='button' className="btnPost" onClick={(e) => handlePresaleAction(e, "save")}>Save</button>
                                                {/* <button type='button' className="btnPost" onClick={(e) => handlePresaleAction(e, "deploy")}>Deploy Contract</button> */}
                                            </div>
                                        </div>
                                    </form>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </div>
    )
}

export default EditPresaleRound